var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 28,
  viewBox: "0 0 40 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.0005 18.1477L35.4063 22.6059L30.8917 27.1429V18.1477H21.7031V0H40.0005V18.1477ZM18.2974 18.1477L13.7814 22.6059L9.18854 27.1429V18.1477H0V0H18.2974V18.1477Z",
  fill: "#4585FF"
})));
export default SvgIconQuote;